import { useMap } from "@vis.gl/react-google-maps";
import React, { useEffect } from "react";

interface Props {
  place: google.maps.places.PlaceResult | null;
  searchCoordinates: string;
}

const MapHandler = ({ place, searchCoordinates }: Props) => {
  const map = useMap();

  useEffect(() => {
    if (!map || !place) return;

    if (place.geometry?.viewport) {
      map.fitBounds(place.geometry?.viewport);
    }
  }, [map, place]);

  useEffect(() => {
    if (!map || !searchCoordinates) return;

    if (searchCoordinates) {
      const parts = searchCoordinates.split(",").map(Number);

      if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
        map.setCenter({ lat: parts[0], lng: parts[1] });
        map.setZoom(14);
      } else {
        console.warn("Invalid Coordinates format:", searchCoordinates);
      }
    }
  }, [map, searchCoordinates]);

  return null;
};

export default React.memo(MapHandler);
